module.exports = __webpack_public_path__ + "static/media/logo_obl.d76c033b.png";